import { Dropdown } from 'primereact/dropdown'
import { InputNumber } from 'primereact/inputnumber'

import { cap } from '../../../State'
import { translations } from '../../../translations'
const language = cap.language.state || 'IT'
const t = translations[language]

const commonProps = {
  className: 'inputNumbers',
  disabled: true,
  mode: 'decimal',
  showButtons: true,
  min: 0,
  max: 50
}

export const NewFilterDropdown = ({
  options,
  name,
  selectedFilters: [selectedFilters, setSelectedFilters],
  flagAbilitazione: [flagAbilitazione, setFlagAbilitazione] = []
}) => {
  const displayOptions =
    options.filter(
      (option) =>
        !Object.values(selectedFilters).some(
          (selectedFilter) => selectedFilter.code === option.code
        )
    ) || []

  if (displayOptions.length) {
    return (
      <div className="community-filter-row community-add-filter">
        <div className="nfield" style={{ minWidth: 200 }}>
          <Dropdown
            onChange={(e) => setSelectedFilters([...selectedFilters, e.value])}
            options={displayOptions}
            optionLabel="name"
            placeholder={t.cpAggiungiFiltro}
            style={{ width: '100%' }}
          />
        </div>
        <div className="nfield">
          <label>{t.nProposte}</label>
          <div className="n-input-number">
            <InputNumber {...commonProps} placeholder={t.nProposte} />
          </div>
        </div>
        {name === 'Treno' && flagAbilitazione && (
          <>
            <div className="nfield">
              <label>{t.cpNRimborsabili}</label>
              <div className="n-input-number">
                <InputNumber {...commonProps} placeholder={t.cpNRimborsabili} />
              </div>
            </div>
            <div className="nfield">
              <label>{t.cpNNonRimborsabili}</label>
              <div className="n-input-number">
                <InputNumber {...commonProps} placeholder={t.cpNNonRimborsabili} />
              </div>
            </div>
          </>
        )}
      </div>
    )
  }
  return null
}
